import { useHead } from "@vueuse/head";
export function usePageMeta(title: string, description: string) {
  useHead({ title, meta: [{ name: "description", content: description }] });
}
